import styled from 'styled-components'

import { Form } from 'antd'

export const FormItemFlex = styled(Form.Item)`
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: space-between;
  }
`

export const FormContainer = styled.div`
  margin: 0 auto;
  width: 28rem;
  max-width: 90vw;
  max-height: 90vh;
  position: relative;
  z-index: 2;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const FormWrapper = styled.div`
  padding: 32px 40px;
  overflow-y: auto;
  flex: 1;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
`

export const FormTitle = styled.h2`
  margin: 0px 0px 8px 0px;
  color: #111827;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
`

export const FormSubtitle = styled.p`
  color: #4B5563;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  text-align: center;
`

export const PageContainer = styled.div`
  background-image: url('/authbgimage.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  position: relative;
  padding: 20px;
  box-sizing: border-box;

  /* Gradient colour overlay on top of the photo */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      hsla(210, 55%, 22%, 0.88) 0%,
      hsla(210, 70%, 15%, 0.92) 100%
    );
    pointer-events: none;
  }

  @media (max-height: 800px) {
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

export const StepsContainer = styled.div`
  margin-bottom: 32px;
  
  .ant-steps-item-title {
    color: #4B5563 !important;
    font-size: 0.75rem !important;
    font-weight: 500 !important;
  }
  
  .ant-steps-item-process .ant-steps-item-title {
    color: hsl(33, 100%, 50%) !important;
    font-weight: 700 !important;
  }
  
  .ant-steps-item-finish .ant-steps-item-title {
    color: #111827 !important;
  }
  
  .ant-steps-item-icon {
    background: #F3F4F6 !important;
    border-color: #D1D5DB !important;
    
    .ant-steps-icon {
      color: #9CA3AF !important;
    }
  }
  
  .ant-steps-item-process .ant-steps-item-icon {
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    
    .ant-steps-icon {
      color: white !important;
    }
  }
  
  .ant-steps-item-finish .ant-steps-item-icon {
    background: #E5E7EB !important;
    border-color: #D1D5DB !important;
    
    .ant-steps-icon {
      color: hsl(33, 100%, 50%) !important;
    }
  }
  
  .ant-steps-item-tail::after {
    background: #E5E7EB !important;
  }
  
  .ant-steps-item-finish .ant-steps-item-tail::after {
    background: hsl(33, 100%, 50%) !important;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  
  .ant-btn {
    height: 44px !important;
    border-radius: 6px !important;
  }
  
  .ant-btn-default {
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    color: white !important;

    &:hover {
      background: rgba(255, 255, 255, 0.15) !important;
      border-color: rgba(255, 255, 255, 0.3) !important;
      color: white !important;
    }
  }
`

export const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 16px !important;
  }

  .ant-input-affix-wrapper, .ant-input {
    background: #F9FAFB !important;
    border: 1px solid #D1D5DB !important;
    border-radius: 6px !important;
    color: #111827 !important;

    .ant-input {
      background: transparent !important;
      color: #111827 !important;
      border: none !important;

      &::placeholder {
        color: #9CA3AF !important;
      }
    }

    .ant-input-prefix {
      color: #9CA3AF !important;
    }

    &:hover, &:focus, &.ant-input-affix-wrapper-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.1) !important;
    }
  }

  .ant-input-password {
    background: #F9FAFB !important;
    border: 1px solid #D1D5DB !important;
    border-radius: 6px !important;

    .ant-input {
      background: transparent !important;
      color: #111827 !important;
      border: none !important;

      &::placeholder {
        color: #9CA3AF !important;
      }
    }

    .ant-input-prefix {
      color: #9CA3AF !important;
    }

    &:hover, &:focus, &.ant-input-password-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.1) !important;
    }
  }

  .ant-select-selector {
    background: #F9FAFB !important;
    border: 1px solid #D1D5DB !important;
    border-radius: 6px !important;
    color: #111827 !important;

    .ant-select-selection-placeholder, .ant-select-selection-item {
      color: #9CA3AF !important;
    }

    &:hover, &.ant-select-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.1) !important;
    }
  }

  .ant-select-dropdown {
    background: #ffffff !important;
    border: 1px solid #E5E7EB !important;

    .ant-select-item {
      color: #111827 !important;

      &:hover {
        background: #F3F4F6 !important;
      }

      &.ant-select-item-option-selected {
        background: hsl(33, 100%, 50%) !important;
        color: white !important;
      }
    }
  }

  .ant-btn-primary {
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    color: white !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.875rem !important;
    height: 44px !important;
    border-radius: 6px !important;

    &:hover {
      background: hsl(33, 100%, 45%) !important;
      border-color: hsl(33, 100%, 45%) !important;
    }
  }

  .ant-btn:not(.ant-btn-primary) {
    height: 44px !important;
    border-radius: 6px !important;
    margin-bottom: 8px !important;
    background: white !important;
    border: 1px solid #D1D5DB !important;
    color: #4B5563 !important;

    &:hover {
      border-color: hsl(33, 100%, 50%) !important;
      color: hsl(33, 100%, 50%) !important;
    }
  }

  .ant-divider {
    margin: 20px 0 !important;
    border-color: #E5E7EB !important;
    
    .ant-divider-inner-text {
      color: #9CA3AF !important;
      font-size: 0.75rem !important;
    }
  }

  .ant-checkbox-wrapper {
    color: #4B5563 !important;

    .ant-checkbox {
      .ant-checkbox-inner {
        background: white !important;
        border-color: #D1D5DB !important;
      }

      &.ant-checkbox-checked .ant-checkbox-inner {
        background: hsl(33, 100%, 50%) !important;
        border-color: hsl(33, 100%, 50%) !important;
      }
    }
  }
`
